module.exports = __webpack_public_path__ + "static/media/appliedblockchain.835f91ed.svg";